import React, {useCallback} from "react";
import MapboxGL, {
  AttributionControl,
  MapProps,
  NavigationControl,
  ScaleControl,
} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../redux/Hooks/storeSelectors";
import {setClickLngLat} from "../../redux/showInfo/showInfoReducer";
import {selectClickableMapboxSourcesIds} from "../../redux/selectors/selectors";
import {MapLayerMouseEvent} from "react-map-gl/dist/esm/types";
import {ENV} from "../../utils/env";
import LineWidthSelectorControl from "./Controls/MapControls/LineWidthControl/LineWidthSelectorControl";


type OmittedProps =
  | "width"
  | "height"
  | "style"
  | "mapboxApiAccessToken"
// | "mapStyle"

export type UpdatedMapProps = Omit<MapProps, OmittedProps>;

const staticStyle = {
  width: "100%",
  height: "100%",
  mapboxAccessToken: ENV.REACT_APP_MAPBOX_ACCESS_TOKEN,
  projection: 'mercator',
  doubleClickZoom: false,
  // mapStyle: "mapbox://styles/mapbox/streets-v11?optimize=true", // mapbox://styles/mapbox/light-v11?optimize=true
};

const MapGL = React.forwardRef((props: UpdatedMapProps, ref) => {
  const clickableSourcesIds = useTypedSelector(selectClickableMapboxSourcesIds);
  const dispatch = useDispatch();

  const onClick = useCallback((e: MapLayerMouseEvent) => {
    const {lngLat: {lng, lat}} = e;
    dispatch(setClickLngLat({lngLat: {lng, lat}}));

    props.onClick && props.onClick(e);
  }, [props, dispatch]);

  const onError = (event) => {
    console.log('==error', event);
  }

  return (
    <MapboxGL
      // reuseMaps={true}
      ref={ref as any}
      {...props as any}
      interactiveLayerIds={clickableSourcesIds}
      {...staticStyle}
      onLoad={props.onLoad}
      onClick={onClick}
      attributionControl={false}
      boxZoom={false}
      // preventStyleDiffing={true}
    >
      <BaseControls/>
      {props.children}
    </MapboxGL>
  );
});

const BaseControls = React.memo(() => {
  return (
    <>
        <LineWidthSelectorControl
            title={"test"}
            position="bottom-right"
            options={{
                '0.5x': {value: '0.5'},
                '1x': {value: '1', selected: true},
                '2x': {value: '2'},
                '3x': {value: '3'},
                '4x': {value: '4'}
            }}
        />
      <AttributionControl
        position="bottom-left"
        compact
      />
      <ScaleControl unit="metric"/>
      <NavigationControl
        showCompass={true}
        visualizePitch={true}
        position="bottom-right"
      />
    </>
  );
});

export default MapGL;
